module.exports = __webpack_public_path__ + "img/mop_icon.52e4c794.svg";